import React, { useEffect } from "react";
import { Spinner } from "@myhealth-raccoon/components";
import { useAsyncData } from "@myhealth-raccoon/services";
import { Navigate, useNavigate } from "react-router-dom";

import { authService } from "src/services/auth";
import { useSelector } from "src/store";

export function Initial() {
    const { clinicId, isNewPatient } = useSelector(state => state.appointment);
    const navigate = useNavigate();

    const { data, error, invoke } = useAsyncData({
        service: authService,
        method: authService.ConnectBookingApp,
        invokeOnMount: false
    }, clinicId, isNewPatient);

    useEffect(() => {
        if (authService.Token.token_type !== "umbraco") {
            navigate("/app/pre-screening", { replace: true });
        } else {
            invoke();
        }
    }, [invoke, navigate]);

    if (data) {
        return <Navigate to="/app/pre-screening" replace />
    }
    return <div className="absolute inset-0 flex items-center justify-center">
        {error
            ? <h2 className="text-lg font-semibold text-error">{error.message || error.name}</h2>
            : <Spinner size="xl" />}
    </div>
}